var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-btn',{directives:[{name:"show",rawName:"v-show",value:(true),expression:"true"}],attrs:{"color":_vm.color,"dark":"","fixed":"","bottom":"","right":"","fab":""},on:{"click":_vm.buttonClicked}},[_c('v-icon',[_vm._v(_vm._s(_vm.icon))])],1)}
var staticRenderFns = []

export { render, staticRenderFns }